import React from 'react'
import { getSiteId, postApiAction } from '../../Utils/helper';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../constants';

const CancelCart = ({closePopup}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const confirmCancel = async () => {
        let resp = await postApiAction("order/cancel", {}, 0, dispatch);
        navigate("/" + getSiteId());
        localStorage.removeItem('booking_reference_id');
        localStorage.removeItem('bookingData');
        // navigate(-1);
    }
  return (
    <div>
        <div className="success-popup-upper">
        <div className="success-popup">
          <img src={`${BASE_URL}/assets/images/sad.png`} />
          <h5>¿Que triste, realmente quieres cancelar tu orden?</h5>
          <div className="popup-button">
            <button onClick={() => closePopup()} className="btn btn-cancel">Cancelar</button>
            <button onClick={confirmCancel} className="btn btn-success">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CancelCart